<app-modal-dialog title="Send onboarding information" (dismiss)="cancel()">

    <main>
        @if(isUpdate()) {
          <h1>Send changes?</h1>
          <br>
          <p>The changes you have made will be sent and processed.</p>
          <br>
          <p>If additional information is required, we will reach out to you.</p>
          <br>
          <p>You may review your selections at any time on this page or through the link provided in our email.<br>In certain cases, we may request modifications and a resubmission. If so, you will receive an email with a link to make the necessary updates.</p>
          <br>
        }
        @else {
          <h1>What happens after you send?</h1>
          <br>
          <p>Your submission will be processed.</p>
          <br>
          <p>If additional information is required, we will reach out to you.</p>
          <br>
          <p>You may review your selections at any time on this page or through the link provided in our email.<br>In certain cases, we may request modifications and a resubmission. If so, you will receive an email with a link to make the necessary updates.</p>
          <br>
        }
    </main>
   
    <footer>
      <div class="button-container">
        <app-button primary width="100%" (buttonClick)="send()">Send</app-button>
        <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>
  
</app-modal-dialog>
   